import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import moment from 'moment';
import 'moment-timezone';

class TimePickerRange extends React.Component {
  constructor(props) {
    super(props);

    moment.locale(props.intl.locale);
    const localeData = moment.localeData();

    this.state = {
      format: localeData.longDateFormat('LT'),
    };
  }

  showAmPm = () => {
    const { format } = this.state;
    if (format.indexOf(' A') !== -1) {
      return true;
    }

    return false;
  };

  getAmPm = which => {
    const { returnTz, displayTz, referenceDate } = this.props;

    const datePrefix = moment(referenceDate || undefined).format('YYYY-MM-DD');

    const hour = moment
      .tz(datePrefix + ' ' + this.props['value' + which] + ':00', returnTz)
      .tz(displayTz)
      .format('HH');

    if (hour >= 12) {
      return 'PM';
    }

    return 'AM';
  };

  addHour = (e, which) => {
    e.preventDefault();
    this.change('hour', 'add', which);
  };

  addMinute = (e, which) => {
    e.preventDefault();
    this.change('minute', 'add', which);
  };

  subHour = (e, which) => {
    e.preventDefault();
    this.change('hour', 'sub', which);
  };

  subMinute = (e, which) => {
    e.preventDefault();
    this.change('minute', 'sub', which);
  };

  getHour = which => {
    const { returnTz, displayTz, referenceDate } = this.props;

    const datePrefix = moment(referenceDate || undefined).format('YYYY-MM-DD');

    const hours = moment
      .tz(datePrefix + ' ' + this.props['value' + which] + ':00', returnTz)
      .tz(displayTz)
      .format('HH');
    if (this.showAmPm()) {
      if (this.getAmPm(which) === 'AM') {
        return hours;
      }

      if (hours > 12) {
        return hours - 12;
      }

      return hours;
    }

    return hours;
  };

  changeAmPm = (e, which) => {
    e.preventDefault();

    const { returnTz, onChange, referenceDate } = this.props;

    const datePrefix = moment(referenceDate || undefined).format('YYYY-MM-DD');

    let newValue = moment.tz(datePrefix + ' ' + this.props['value' + which] + ':00', returnTz);
    if (this.getAmPm(which) === 'AM') {
      // add 12 hours
      newValue = newValue.add(moment.duration(12, 'hours'));
    } else {
      // substract 12 hours
      newValue = newValue.subtract(moment.duration(12, 'hours'));
    }

    if (onChange) {
      onChange(newValue.format('HH:mm'), which);
    }
  };

  change = (what, action, which) => {
    // calculate new value
    const { returnTz, onChange, referenceDate } = this.props;

    const datePrefix = moment(referenceDate || undefined).format('YYYY-MM-DD');

    const newValue = moment.tz(datePrefix + ' ' + this.props['value' + which] + ':00', returnTz);
    if (action === 'add') {
      newValue.add(moment.duration(this.props[what + 'Steps'], what));
    } else {
      newValue.subtract(moment.duration(this.props[what + 'Steps'], what));
    }

    if (onChange) {
      onChange(newValue.format('HH:mm'), which);
    }
  };

  getTimePickerTable = which => {
    const { displayTz, returnTz, referenceDate } = this.props;

    const datePrefix = moment(referenceDate || undefined).format('YYYY-MM-DD');

    return (
      <table class="table-condensed">
        <tbody>
          <tr>
            <td>
              <a
                href="#addHour"
                class="btn"
                onClick={e => {
                  this.addHour(e, which);
                }}
              >
                <span class="fas fa-chevron-up" />
              </a>
            </td>
            <td class="separator" />
            <td>
              <a
                href="#addMinute"
                class="btn"
                onClick={e => {
                  this.addMinute(e, which);
                }}
              >
                <span class="fas fa-chevron-up" />
              </a>
            </td>
            {this.showAmPm() && <td class="separator" />}
          </tr>
          <tr>
            <td class="text-center">
              <span class="timepicker-hour">{this.getHour(which)}</span>
            </td>
            <td class="separator">:</td>
            <td class="text-center">
              <span class="timepicker-minute">
                {moment
                  .tz(moment(datePrefix + ' ' + this.props['value' + which] + ':00'), returnTz)
                  .tz(displayTz)
                  .format('mm')}
              </span>
            </td>
            {this.showAmPm() && (
              <td>
                <button
                  className="btn btn-info"
                  type="button"
                  onClick={e => {
                    this.changeAmPm(e, which);
                  }}
                >
                  {this.getAmPm(which)}
                </button>
              </td>
            )}
          </tr>
          <tr>
            <td>
              <a
                href="#subHour"
                class="btn"
                onClick={e => {
                  this.subHour(e, which);
                }}
              >
                <span class="fas fa-chevron-down" />
              </a>
            </td>
            <td class="separator" />
            <td>
              <a
                href="#subMinute"
                class="btn"
                onClick={e => {
                  this.subMinute(e, which);
                }}
              >
                <span class="fas fa-chevron-down" />
              </a>
            </td>
            {this.showAmPm() && <td class="separator" />}
          </tr>
        </tbody>
      </table>
    );
  };

  render() {
    const { layout } = this.props;

    return layout.breakpoint === 'xs' ? (
      <div class="timepicker-picker block">
        {this.getTimePickerTable('Start')}
        {this.getTimePickerTable('End')}
      </div>
    ) : (
      <div class="timepicker-picker block">
        <table>
          <tbody>
            <tr>
              <td>{this.getTimePickerTable('Start')}</td>
              <td>{this.getTimePickerTable('End')}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}
TimePickerRange.propTypes = {};
TimePickerRange.defaultProps = {
  referenceDate: undefined,
  displayTz: 'UTC',
  returnTz: 'UTC',
  disabled: false,
  locale: 'en',
  minuteSteps: 5,
  hourSteps: 1,
  valueStart: '08:30',
  valueEnd: '16:30',
};

const mapStateToProps = state => {
  return {
    layout: state.layout,
  };
};

export default injectIntl(connect(mapStateToProps)(TimePickerRange));
